export const recaptcha = {
  // key: '6LeC9LYUAAAAANYWUXQDzUG35fRaLKkoRJaoqLho' // local
  key: '6LdQ1rYUAAAAAPDtApuoGy3HbrIigp8fz4QXewjU' // staging
}

export const api = {
  // baseURL: 'http://localhost:5001/csx-sales-marketing/us-central1' // local
  baseURL: 'https://us-central1-csx-sales-lp.cloudfunctions.net/addSubmission' // prod
}
